import { AddMemberTeamFormValues, ValidationFormErrors, ValidationFormsModeEnum } from "./types";

export function validateAddMemberTeam(
  values: AddMemberTeamFormValues,
  mode: ValidationFormsModeEnum,
  original?: AddMemberTeamFormValues
): ValidationFormErrors {
  const errors: ValidationFormErrors = {};

  if (!values.firstName || values.firstName.trim() === "") {
    errors.firstName = "Введіть ім’я.";
  }

  if (!values.lastName || values.lastName.trim() === "") {
    errors.lastName = "Введіть прізвище.";
  }

  if (!values.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
    errors.email = "Введіть коректний email.";
  }

  if (mode === "edit" && original) {

  }

  return errors;
}